import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import Presenter from "./Presenter";
import OtherInfoForm from "./otherInfo/OtherInfoForm";
import EditOtherInfoForm from "./otherInfo/EditOtherInfoForm";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class EducationalPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      level: "",
      selectedLevel: "",
      email: sessionStorage.getItem("email"),
      initialData: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCurrent() {
    return this.props.object.id;
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.schoolName)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.schoolName)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("Education", JSON.stringify(newObjects));
      }
    }
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newOject = await findObjectUseCase().execute(
      "educational_background",
      { where: { empID: this.props.object.id } }
    );
    this.setState({ initialData: newOject });
  }
  getCollectionName() {
    return "educational_background";
  }
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute(
    //   "educational_background",
    //   { where: { id: id } }
    // );
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteEducation")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteEducation", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute(
    //   "educational_background",
    //   id
    // );
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, "educational_background", () =>
      this.refetchData()
    );
  }

  handleObjectData(data) {
    dialog.fire({
      html: (
        <div className="p-3">
          <EditOtherInfoForm
            refetchData={() => this.refetchData()}
            object={data}
            email={this.props.object.email}
            empID={this.props.object.id}
          />
        </div>
      ),
      footer: false,
    });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  educationalBackground() {
    dialog.fire({
      html: (
        <div className="p-3">
          <OtherInfoForm
            refetchData={() => this.refetchData()}
            email={this.props.object.email}
            empID={this.props.object.id}
          />
        </div>
      ),
      footer: false,
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll className="h-100">
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.educationalBackground.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Educational Background
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default EducationalPage;
